<style lang="stylus">
    .FormulaModal-mask
        position fixed
        top 0
        left 0
        width 100vw
        height 100vh
        z-index 23333
        .FormulaModal-container
            position fixed
            left 0
            right 0
            top 0
            bottom 0
            margin auto
            width 400px
            height 300px
            border-radius 5px
            background-color var(--bg-color-dialog-container)
            box-shadow $modal-shadow
            z-index 4
            .formulaHeader
                position relative
                height 30px
                border-bottom 1px solid #cecece
                border-top-left-radius 5px
                border-top-right-radius 5px
                .formulaHeader-title
                    float left
                    font-size 14px
                    color $modal-title-textcolor
                    margin-left 23px
                    margin-top 4px
                .formulaHeader-close
                    float right
                    position relative
                    width 15px
                    height 15px
                    margin-top 8px
                    margin-right 8px
                    cursor pointer
                .formulaHeader-close::before
                    content ''
                    position absolute
                    left 8px
                    width 1px
                    height 15px
                    background-color $modal-title-textcolor
                    transform rotate(42deg)
                .formulaHeader-close::after
                    content ''
                    position absolute
                    left 8px
                    width 1px
                    height 15px
                    background-color $modal-title-textcolor
                    transform rotate(-42deg)
            .formulaBody
                padding 8px 23px
                .body-titlebox
                    width 100%
                    p
                        float left
                        font-size 14px
                        &:nth-child(1)
                            width 33%
                        &:nth-child(2)
                            width 33%
                        &:nth-child(3)
                            width 33%
                .body-line
                    height 40px
                    .formula-formulabox
                        float left
                        position relative
                        .formulabox-name
                            width 100px
                            height 20px
                            font-size 12px
                            border 1px solid #ddd
                            text-align center
                            cursor pointer
                        .formulabox-list
                            position absolute
                            box-shadow 0 0 9px #d7d7d7
                            background-color #fff
                            z-index 23333
                            width 120px
                            max-height 400px
                            overflow-y auto
                            li
                                list-style none
                                cursor pointer
                                text-align center
                                &:hover
                                    background-color #dedede
                        &:nth-child(1)
                            width 33%
                        &:nth-child(2)
                            width 33%
                        &:nth-child(3)
                            width 33%
                    .line-numberinput
                        width 100%
                        height 40px
                        padding 10px 0
                        p
                            float left
                            width 80px
                            margin-right 20px
                        input
                            float left
                    .formulabox-input
                        float left
                        width 100px
                        height 20px
                        font-size 12px
                        border 1px solid #ddd
                    .formulabox-checkbox
                        width 200px
                        height 20px
                        margin-top 15px
                        p
                            float left
                            width 50px
                            margin-right 20px
                        div
                            float left
                            position relative
                            width 16px
                            height 16px
                            border 1px solid #a9a9a9
                            border-radius 3px
                            background #fff
                            cursor pointer
                        div.checked
                            background var(--themeColor)
                            border-color var(--themeColor)
                        div.checked:after
                            content ''
                            position absolute
                            top 3px
                            left 3px
                            background transparent
                            border 2px solid #ffffff
                            border-top none
                            border-right none
                            height 6px
                            width 8px
                            transform rotate(-45deg)
                .formulaBody-btnbox
                    position absolute
                    bottom 20px
                    right 20px
                    width 180px
                    div
                        float left
                        width 80px
                        height 23px
                        text-align center
                        line-height 23px
                        border-radius 5px
                        border 1px solid #ddd
                        color #353535
                        font-size 12px
                        cursor pointer
                        user-select none
                        &:hover
                            background-color #ddd
                        &:nth-child(1)
                            margin-right 20px
</style>

<template>
    <div class="FormulaModal-mask">
        <div class="FormulaModal-container">
            <div class="formulaHeader">
                <p class="formulaHeader-title">{{ $t("title") }}</p>
                <div class="formulaHeader-close" @click="clickCancel()"></div>
            </div>
            <div class="formulaBody">
                <div class="body-titlebox">
                    <p>{{ $t("type") }}:</p>
                    <p>{{ $t("function") }}:</p>
                    <p>{{ $t("range") }}:</p>
                </div>
                <div class="body-line">
                    <div class="formula-formulabox" v-click-outside="closeTypeBox">
                        <p class="formulabox-name" v-text="typeText" @click="clickTypeName()"></p>
                        <ul class="formulabox-list" v-show="showType">
                            <li v-for="(item, index) in typeList" :key="index" @click="clickTypeList(index)">{{ item.name }}</li>
                        </ul>
                    </div>
                    <div class="formula-formulabox" v-click-outside="closeFucBox">
                        <p class="formulabox-name" @click="clickFunctionName()">{{ $t(FunctionText) }}</p>
                        <ul class="formulabox-list" v-show="showFunction">
                            <li v-for="(item, index) in FunctionList" :key="index" @click="clickFunctionList(index)">{{ $t(item.name) }}</li>
                        </ul>
                    </div>
                    <div class="formula-formulabox" v-click-outside="closeRangeBox">
                        <p class="formulabox-name" @click="clickRangeName()">{{ $t(RangeText) }}</p>
                        <ul class="formulabox-list" v-show="showRange">
                            <li v-for="(item, index) in RangeList" :key="index" @click="clickRangeList(index)">{{ $t(item.name) }}</li>
                        </ul>
                    </div>
                </div>

                <div class="body-line" style="height: 80px">
                    <div class="line-numberinput" v-if="FunctionText == 'Left' || FunctionText == 'Right'">
                        <p>{{ $t("charra") }}:</p>
                        <InputNumber
                            v-model="ValueInput2"
                            size="small"
                            :max="9007199254740992"
                            @on-focus="editLocker('focus', 'inputLocker')"
                            @on-blur="
                                editLocker('blur', 'inputLocker', () => {
                                    inputNum(2);
                                })
                            "
                            @on-change="
                                editLocker('edit', 'inputLocker', () => {
                                    inputNum(2);
                                })
                            "
                        ></InputNumber>
                    </div>
                    <div class="line-numberinput" v-if="FunctionText == 'Mid'">
                        <p>{{ $t("start") }}:</p>
                        <InputNumber
                            v-model="ValueInput3"
                            size="small"
                            :max="9007199254740992"
                            @on-focus="editLocker('focus', 'inputLocker')"
                            @on-blur="
                                editLocker('blur', 'inputLocker', () => {
                                    inputNum(3);
                                })
                            "
                            @on-change="
                                editLocker('edit', 'inputLocker', () => {
                                    inputNum(3);
                                })
                            "
                        ></InputNumber>
                    </div>
                    <div class="line-numberinput" v-if="FunctionText == 'Mid'">
                        <p>{{ $t("characters") }}:</p>
                        <InputNumber
                            v-model="ValueInput5"
                            size="small"
                            :max="9007199254740992"
                            @on-focus="editLocker('focus', 'inputLocker')"
                            @on-blur="
                                editLocker('blur', 'inputLocker', () => {
                                    inputNum(4);
                                })
                            "
                            @on-change="
                                editLocker('edit', 'inputLocker', () => {
                                    inputNum(4);
                                })
                            "
                        ></InputNumber>
                    </div>
                    <div class="line-numberinput" v-if="FunctionText == 'Contain'">
                        <p>{{ $t("string") }}:</p>
                        <InputNumber
                            v-model="ValueInput5"
                            size="small"
                            :max="9007199254740992"
                            @on-focus="editLocker('focus', 'inputLocker')"
                            @on-blur="
                                editLocker('blur', 'inputLocker', () => {
                                    inputNum(5);
                                })
                            "
                            @on-change="
                                editLocker('edit', 'inputLocker', () => {
                                    inputNum(5);
                                })
                            "
                        ></InputNumber>
                    </div>
                </div>

                <div class="body-line" v-if="FunctionText == 'Equals' || FunctionText == 'Total'">
                    <div class="formula-formulabox">
                        <p class="formulabox-name" v-text="SignText0" @click="clickSignName(0)"></p>
                        <ul class="formulabox-list" v-show="showSign0">
                            <li v-for="(item, index) in SignList" :key="index" @click="clickSignList(index, 0)">{{ item.name }}</li>
                        </ul>
                    </div>
                    <div class="formula-formulabox">
                        <p class="formulabox-name" v-text="ValueText0" @click="clickValueName(0)"></p>
                        <ul class="formulabox-list" v-show="showValue0">
                            <li v-for="(item, index) in ValueList" :key="index" @click="clickValueList(index, 0)">{{ item.name }}</li>
                        </ul>
                    </div>
                    <InputNumber
                        v-if="ValueText0 === 'Value'"
                        v-model="ValueInput0"
                        size="small"
                        :max="9007199254740992"
                        @on-focus="editLocker('focus', 'inputLocker')"
                        @on-blur="
                            editLocker('blur', 'inputLocker', () => {
                                inputNum(0);
                            })
                        "
                        @on-change="
                            editLocker('edit', 'inputLocker', () => {
                                inputNum(0);
                            })
                        "
                    ></InputNumber>
                    <div class="formula-formulabox" v-else>
                        <p class="formulabox-name" v-text="PropertyText0" @click="clickPropertyName(0)"></p>
                        <ul class="formulabox-list" v-show="showProperty0">
                            <li v-for="(item, index) in PropertyList" :key="index" @click="clickPropertyList(index, 0)">{{ item.name }}</li>
                        </ul>
                    </div>
                </div>

                <div class="body-line" v-if="FunctionText == 'Equals' || FunctionText == 'Total'">
                    <div class="formula-formulabox">
                        <p class="formulabox-name" v-text="SignText1" @click="clickSignName(1)"></p>
                        <ul class="formulabox-list" v-show="showSign1">
                            <li v-for="(item, index) in SignList" :key="index" @click="clickSignList(index, 1)">{{ item.name }}</li>
                        </ul>
                    </div>
                    <div class="formula-formulabox">
                        <p class="formulabox-name" v-text="ValueText1" @click="clickValueName(1)"></p>
                        <ul class="formulabox-list" v-show="showValue1">
                            <li v-for="(item, index) in ValueList" :key="index" @click="clickValueList(index, 1)">{{ item.name }}</li>
                        </ul>
                    </div>
                    <InputNumber
                        v-if="ValueInput1 === 'Value'"
                        v-model="ValueInput1"
                        size="small"
                        :max="9007199254740992"
                        @on-focus="editLocker('focus', 'inputLocker')"
                        @on-blur="
                            editLocker('blur', 'inputLocker', () => {
                                inputNum(1);
                            })
                        "
                        @on-change="
                            editLocker('edit', 'inputLocker', () => {
                                inputNum(1);
                            })
                        "
                    ></InputNumber>
                    <div class="formula-formulabox" v-else>
                        <p class="formulabox-name" v-text="PropertyText1" @click="clickPropertyName(1)"></p>
                        <ul class="formulabox-list" v-show="showProperty1">
                            <li v-for="(item, index) in PropertyList" :key="index" @click="clickPropertyList(index, 1)">{{ item.name }}</li>
                        </ul>
                    </div>
                </div>

                <div class="body-line">
                    <div class="formulabox-checkbox" v-if="RangeText == 'Level' || RangeText == 'Sub'">
                        <p>{{ $t("assistants") }}:</p>
                        <div :class="{ checked: AssistantsChecked }" @click="clickCheckBox(0)"></div>
                    </div>
                    <div class="formulabox-checkbox" v-if="RangeText == 'Sub'">
                        <p>{{ $t("self") }}:</p>
                        <div :class="{ checked: SelfChecked }" @click="clickCheckBox(1)"></div>
                    </div>
                </div>

                <div class="body-line" v-if="FunctionText == 'Years' || FunctionText == 'Day'">
                    <DatePicker :value="dataValue" type="date" placeholder="Select date" style="width: 200px" @on-change="selectDate"></DatePicker>
                </div>

                <div class="formulaBody-btnbox">
                    <div @click="selectOk()">{{ $t("confirm") }}</div>
                    <div @click="clickCancel()">{{ $t("cancel") }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {},
    })
    export default class FormulaModal extends Vue {
        @Prop()
        basedata: Array<object>;
        fomula: Array<string> = [];
        typeText: string = "";
        showType: boolean = false;
        typeList: Array<Object> = [];

        FunctionText: string = "";
        showFunction: boolean = false;
        FunctionList: Array<Object> = [];
        FunctionListOne: Array<Object> = [
            {
                id: 0,
                name: "Len",
                num: "50",
            },
            {
                id: 1,
                name: "Left",
                num: "51",
            },
            {
                id: 2,
                name: "Mid",
                num: "52",
            },
            {
                id: 3,
                name: "Right",
                num: "53",
            },
            {
                id: 4,
                name: "Lower",
                num: "54",
            },
            {
                id: 5,
                name: "Upper",
                num: "55",
            },
            {
                id: 6,
                name: "Contain",
                num: "56",
            },
            {
                id: 7,
                name: "Reports to",
                num: "57",
            },
        ];
        FunctionListTwo: Array<Object> = [
            {
                id: 0,
                name: "Average",
                num: "10",
            },
            {
                id: 1,
                name: "Equals",
                num: "11",
            },
            {
                id: 2,
                name: "Total",
                num: "12",
            },
            {
                id: 3,
                name: "Maximum",
                num: "13",
            },
            {
                id: 4,
                name: "Minimum",
                num: "14",
            },
            {
                id: 5,
                name: "Variance",
                num: "15",
            },
            {
                id: 6,
                name: "Standard Deviation",
                num: "16",
            },
        ];
        FunctionListThree: Array<Object> = [
            {
                id: 0,
                name: "Years",
                num: "30",
            },
            {
                id: 1,
                name: "Day",
                num: "31",
            },
        ];
        FunctionListFour: Array<Object> = [
            {
                id: 0,
                name: "count",
                num: "80",
            },
        ];

        RangeText: string = "";
        showRange: boolean = false;
        RangeList: Array<object> = [];
        RangeListOne: Array<object> = [
            {
                id: 0,
                name: "Self",
                num: "0",
            },
        ];
        RangeListTwo: Array<object> = [
            {
                id: 0,
                name: "Self",
                num: "0",
            },
            {
                id: 1,
                name: "Level",
                num: "1",
            },
            {
                id: 2,
                name: "Sub",
                num: "2",
            },
            {
                id: 3,
                name: "All",
                num: "3",
            },
        ];
        RangeListThree: Array<object> = [
            {
                id: 0,
                name: "Next Level Sub",
                num: "0",
            },
            {
                id: 1,
                name: "All Sub",
                num: "1",
            },
        ];

        SignText0: string = "";
        showSign0: boolean = false;
        SignList: Array<object> = [
            {
                id: 0,
                name: " ",
            },
            {
                id: 1,
                name: "+",
            },
            {
                id: 2,
                name: "-",
            },
            {
                id: 3,
                name: "*",
            },
            {
                id: 4,
                name: "/",
            },
        ];
        ValueText0: string = "Value";
        showValue0: boolean = false;
        ValueList: Array<object> = [
            {
                id: 0,
                name: "Value",
            },
            {
                id: 1,
                name: "Property",
            },
        ];
        PropertyText0: string = "";
        showProperty0: boolean = false;
        PropertyList: Array<object> = [];

        SignText1: string = "";
        showSign1: boolean = false;
        ValueText1: string = "Value";
        showValue1: boolean = false;
        PropertyText1: string = "";
        showProperty1: boolean = false;
        AssistantsChecked: boolean = false;
        SelfChecked: boolean = false;
        dataValue: any = "";

        ValueInput0: number = 0;
        ValueInput1: number = 0;
        ValueInput2: number = 0;
        ValueInput3: number = 0;
        ValueInput4: number = 0;
        ValueInput5: string = "";
        inputLocker: boolean = false;

        editLocker(type, lock, fn?) {
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        fn();
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                        }
                    },
                ],
            ]);
            map.get(type)();
        }
        clickTypeName() {
            this.showType = true;
        }
        clickTypeList(index) {
            this.showType = false;
            this.typeText = this.typeList[index]["name"];
            this.fomula[0] = this.typeText;
            this.resetList(1, index);
            this.resetList(2, index);
        }
        closeTypeBox() {
            this.showType = false;
        }
        clickFunctionName() {
            this.showFunction = true;
        }
        clickFunctionList(index) {
            this.showFunction = false;
            this.FunctionText = this.FunctionList[index]["name"];
            this.fomula[1] = this.FunctionList[index]["num"];
            this.resetList(2, index);
        }
        closeFucBox() {
            this.showFunction = false;
        }
        clickRangeName() {
            this.showRange = true;
        }
        clickRangeList(index) {
            this.showRange = false;
            this.fomula[2] = this.RangeList[index]["num"];
            this.RangeText = this.RangeList[index]["name"];
        }
        closeRangeBox() {
            this.showRange = false;
        }
        clickSignName(type) {
            if (type == 0) {
                this.showSign0 = true;
            } else {
                this.showSign1 = true;
            }
        }
        clickSignList(index, type) {
            if (type == 0) {
                this.showSign0 = false;
                this.SignText0 = this.SignList[index]["name"];
            } else {
                this.showSign1 = false;
                this.SignText1 = this.SignList[index]["name"];
            }
            this.fomula[5 + type * 2] = "" + this.SignList[index]["id"];
        }
        clickValueName(type) {
            if (type == 0) {
                this.showValue0 = true;
            } else {
                this.showValue1 = true;
            }
        }
        clickValueList(index, type) {
            if (type == 0) {
                this.showValue0 = false;
                this.ValueText0 = this.ValueList[index]["name"];
            } else {
                this.showValue1 = false;
                this.ValueText1 = this.ValueList[index]["name"];
            }
            this.fomula[6 + type * 2] = "" + this.SignList[index]["name"];
        }
        clickPropertyName(type) {
            if (type == 0) {
                this.showProperty0 = true;
            } else {
                this.showProperty1 = true;
            }
        }
        clickPropertyList(index, type) {
            if (type == 0) {
                this.showProperty0 = false;
                this.PropertyText0 = this.PropertyList[index]["name"];
            } else {
                this.showProperty1 = false;
                this.PropertyText1 = this.PropertyList[index]["name"];
            }
        }

        clickCheckBox(type) {
            if (type == 0) {
                this.AssistantsChecked = !this.AssistantsChecked;
                if (this.AssistantsChecked) {
                    this.fomula[3] = "1";
                } else {
                    this.fomula[3] = "0";
                }
            } else {
                this.SelfChecked = !this.SelfChecked;
                if (this.AssistantsChecked) {
                    this.fomula[4] = "1";
                } else {
                    this.fomula[4] = "0";
                }
            }
        }
        inputNum(type) {
            switch (type) {
                case 0: {
                    this.fomula[6] = "" + this.ValueInput0;
                    break;
                }
                case 1: {
                    this.fomula[8] = "" + this.ValueInput1;
                    break;
                }
                case 2: {
                    this.fomula[3] = "" + this.ValueInput2;
                    break;
                }
                case 3: {
                    this.fomula[3] = "" + this.ValueInput3;
                    break;
                }
                case 4: {
                    this.fomula[4] = "" + this.ValueInput4;
                    break;
                }
                case 5: {
                    this.fomula[5] = this.ValueInput5;
                    break;
                }
            }
        }
        selectDate(name) {
            this.fomula[3] = name;
        }
        resetList(type, index) {
            switch (type) {
                case 0: {
                    this.typeList = this.basedata.filter((v, k) => {
                        if (v["type"] === 0) {
                            return v;
                        } else if (v["type"] == 1) {
                            return v;
                        } else if (v["type"] == 4) {
                            return v;
                        } else if (v["type"] == 2) {
                            return v;
                        }
                    });
                    this.typeList.push({ name: "others", type: -1 });
                    this.typeText = this.typeList[0]["name"];
                    break;
                }
                case 1: {
                    this.FunctionList =
                        this.typeList[index]["type"] == 0
                            ? this.FunctionListOne
                            : this.typeList[index]["type"] == 1
                              ? this.FunctionListTwo
                              : this.typeList[index]["type"] == 2 || this.typeList[index]["type"] == 4
                                ? this.FunctionListThree
                                : this.FunctionListFour;
                    this.FunctionText = this.FunctionList[0]["name"];
                    break;
                }
                case 2: {
                    let arr = ["Average", "Total", "maximum", "minimum", "Variance", "Standard Deviation"];
                    this.RangeList = arr.includes(this.FunctionText)
                        ? this.RangeListTwo
                        : this.FunctionText === "count"
                          ? this.RangeListThree
                          : this.RangeListOne;
                    this.RangeText = this.RangeList[0]["name"];
                    break;
                }
            }
        }
        selectOk() {
            let Data = this.fomula.join("|");
            this.$emit("changeFormula", Data);
        }
        clickCancel() {
            this.$emit("cancelFormula");
        }
        //生命周期
        mounted() {}
        created() {
            this.PropertyList = this.basedata.filter((v, k) => {
                if (v["type"] == 1) {
                    return v;
                }
            });
            this.typeList = this.basedata.filter((v, k) => {
                if (v["type"] === 0) {
                    return v;
                } else if (v["type"] == 1) {
                    return v;
                } else if (v["type"] == 4) {
                    return v;
                } else if (v["type"] == 2) {
                    return v;
                }
            });
            this.typeList.push({ name: "others", type: -1 });
            this.typeText = this.typeList[0]["name"];
            this.FunctionList =
                this.typeList[0]["type"] == 0
                    ? this.FunctionListOne
                    : this.typeList[0]["type"] == 1
                      ? this.FunctionListTwo
                      : this.typeList[0]["type"] == 2 || this.typeList[0]["type"] == 4
                        ? this.FunctionListThree
                        : this.FunctionListFour;
            this.FunctionText = this.FunctionList[0]["name"];
            let arr = ["Average", "Total", "maximum", "minimum", "Variance", "Standard Deviation"];
            this.RangeList = arr.includes(this.FunctionText)
                ? this.RangeListTwo
                : this.FunctionText === "count"
                  ? this.RangeListThree
                  : this.RangeListOne;
            this.RangeText = this.RangeList[0]["name"];
            this.fomula = [this.typeText, "0", "0"];
        }
        beforeDestroy() {}
    }
</script>
<i18n>
{
  "zh": {
    "title": "公式",
    "type": "类型",
    "function": "函数",
    "range": "范围",
    "charra": "晚间",
    "start": "开始",
    "characters": "角色",
    "string": "字符",
    "assistants": "助手",
    "self": "自身",
    "Len": "长度",
    "Left": "左",
    "Mid": "中",
    "Right": "右",
    "Lower": "小写",
    "Upper": "大写",
    "Contain": "包含",
    "Reports to": "报告给",
    "Self": "自身",
    "Average": "平均数",
    "Equals": "等于",
    "Total": "总数",
    "Maximum": "最大",
    "Minimum": "最小",
    "Variance": "方差",
    "Standard Deviation": "标准差",
    "Years": "年",
    "Day": "日",
    "count": "计数",
    "Level": "同级",
    "Sub": "附属",
    "All": "全部",
    "Next Level Sub": "下一层级附属",
    "All Sub": "全部附属",
    "Value": "值",
    "Property": "属性",
    "confirm": "确定",
    "cancel": "取消"
  },
  "en": {
    "title": "Formula",
    "type": "Type",
    "function": "Function",
    "charra": "Charra",
    "start": "Start",
    "characters": "Characters",
    "string": "String",
    "assistants": "Assistants",
    "self": "Self",
    "range": "Range",
    "Len": "Len",
    "Left": "Left",
    "Mid": "Mid",
    "Right": "Right",
    "Lower": "Lower",
    "Upper": "Upper",
    "Contain": "Contain",
    "Reports to": "Reports to",
    "Self": "Self",
    "Average": "Average",
    "Equals": "Equals",
    "Total": "Total",
    "Maximum": "Maximum",
    "Minimum": "Minimum",
    "Variance": "Variance",
    "Standard Deviation": "Standard Deviation",
    "Years": "Years",
    "Day": "Day",
    "count": "count",
    "Level": "Level",
    "Sub": "Sub",
    "All": "All",
    "Next Level Sub": "Next Level Sub",
    "All Sub": "All Sub",
    "Value": "Value",
    "Property": "Property",
    "confirm": "OK",
    "cancel": "Cancel"
  },
  "de": {
    "title": "Formel",
    "type": "Typ",
    "function": "Funktion",
    "range": "Bereich",
    "charra": "Chakra",
    "start": "Start",
    "characters": "Rolle",
    "string": "Zeichen",
    "assistants": "Assistant",
    "self": "Selbst",
    "Len": "Länge",
    "Left": "Links",
    "Mid": "Mitte",
    "Right": "Rechts",
    "Lower": "Kleinbuchstaben",
    "Upper": "Großbuchstaben",
    "Contain": "Enthalten",
    "Reports to": "Bericht an",
    "Self": "Selbst",
    "Average": "Durchschnitt",
    "Equals": "Entspricht",
    "Total": "Gesamt",
    "Maximum": "Maximum",
    "Minimum": "Minimum",
    "Variance": "Varianz",
    "Standard Deviation": "Standardabweichung",
    "Years": "Jahr",
    "Day": "Tag",
    "count": "Anzahl",
    "Level": "Ebene",
    "Sub": "Angeschlossene",
    "All": "Alles",
    "Next Level Sub": "Nächste Stufe angeschlossen",
    "All Sub": "Alle verbundenen",
    "Value": "Wert",
    "Property": "Eigenschaft",
    "confirm": "Sichern",
    "cancel": "Abbrechen"
  },
  "fr": {
    "title": "Officiel",
    "type": "type",
    "function": "Fonction",
    "range": "Gamme",
    "charra": "soirée",
    "start": "Commencer",
    "characters": "Rôle",
    "string": "caractères",
    "assistants": "Assistante",
    "self": "Soi",
    "Len": "Longueur",
    "Left": "Gauche",
    "Mid": "Milieur",
    "Right": "Droite",
    "Lower": "Minuscules",
    "Upper": "Majuscules",
    "Contain": "Contenir",
    "Reports to": "Faire rapport à",
    "Self": "Soi",
    "Average": "Moyenne",
    "Equals": "Égal à",
    "Total": "Total",
    "Maximum": "Maximum",
    "Minimum": "Minimum",
    "Variance": "Écart",
    "Standard Deviation": "Écart type",
    "Years": "Année",
    "Day": "Jour",
    "count": "Compter",
    "Level": "Peer",
    "Sub": "Sous",
    "All": "Tous",
    "Next Level Sub": "Affiliée niveau suivant",
    "All Sub": "toutes les filiales",
    "Value": "Valeur",
    "Property": "Attribut",
    "confirm": "OK",
    "cancel": "Annuler"
  },
  "jp": {
    "title": "公式",
    "type": "タイプ",
    "function": "関数",
    "range": "範囲",
    "charra": "夜",
    "start": "スタート",
    "characters": "キャラクタ",
    "string": "ストリング",
    "assistants": "アシスタント",
    "self": "自身",
    "Len": "長さ",
    "Left": "左",
    "Mid": "中",
    "Right": "右",
    "Lower": "小文字",
    "Upper": "大文字",
    "Contain": "含む",
    "Reports to": "に報告する",
    "Self": "自身",
    "Average": "平均値",
    "Equals": "に等しい",
    "Total": "トータル",
    "Maximum": "最大値",
    "Minimum": "最小値",
    "Variance": "偏差",
    "Standard Deviation": "標準偏差",
    "Years": "年",
    "Day": "日",
    "count": "カウント",
    "Level": "レベル",
    "Sub": "サブ",
    "All": "すべて",
    "Next Level Sub": "次のレベルのサブ",
    "All Sub": "すべてのサブ",
    "Value": "値",
    "Property": "属性",
    "confirm": "OK",
    "cancel": "キャンセル"
  },
  "es": {
    "title": "Fórmula",
    "type": "Tipo",
    "function": "Función",
    "range": "Rango",
    "charra": "Charra",
    "start": "Inicio",
    "characters": "Caracteres",
    "string": "Cuerda",
    "assistants": "Asistentes",
    "self": "Auto",
    "Len": "Longitud",
    "Left": "Izquierdo",
    "Mid": "Centro",
    "Right": "Derecho",
    "Lower": "小Inferior",
    "Upper": "Superior",
    "Contain": "Contiene",
    "Reports to": "Informa a",
    "Self": "Auto",
    "Average": "Promedio",
    "Equals": "Igual ",
    "Total": "Total",
    "Maximum": "Máximo",
    "Minimum": "Mínimo",
    "Variance": "Diferencia",
    "Standard Deviation": "Desviación Estándar",
    "Years": "Años",
    "Day": "Día",
    "count": "contar",
    "Level": "Nivel",
    "Sub": "Sub",
    "All": "Todos ",
    "Next Level Sub": "Sub Nivel Siguiente",
    "All Sub": "All Sub",
    "Value": "Valor",
    "Property": "Propiedad",
    "confirm": "Aceptar",
    "cancel": "Cancelar"
  },
  "pt": {
    "title": "Fórmula",
    "type": "Tipo",
    "function": "Função",
    "charra": "Charra",
    "start": "Iniciar",
    "characters": "Caracteres",
    "string": "Corda",
    "assistants": "Assistentes",
    "self": "A Si Próprio",
    "range": "Gama",
    "Len": "Len",
    "Left": "Esquerda",
    "Mid": "Meio",
    "Right": "Direita",
    "Lower": "Menor",
    "Upper": "Maior",
    "Contain": "Conter",
    "Reports to": "Reportar a",
    "Self": "A Si Próprio",
    "Average": "Média",
    "Equals": "Iguais",
    "Total": "Total",
    "Maximum": "Máximo",
    "Minimum": "Mínimo",
    "Variance": "Variância",
    "Standard Deviation": "Desvio Padrão",
    "Years": "Anos",
    "Day": "Dia",
    "count": "contar",
    "Level": "Nível",
    "Sub": "Sub",
    "All": "Todo",
    "Next Level Sub": "Sub de Próximo Nível",
    "All Sub": "Todos os Sub",
    "Value": "Valor",
    "Property": "Propriedade",
    "confirm": "OK",
    "cancel": "Cancelar"
  },
  "it": {
    "title": "Formula",
    "type": "Tipo",
    "function": "Funzione",
    "charra": "Num.Caratteri",
    "start": "Avvia",
    "characters": "Caratteri",
    "string": "Serie",
    "assistants": "Assistenti",
    "self": "Sé Stesso",
    "range": "Intervallo",
    "Len": "Lunghezza",
    "Left": "Sinistra",
    "Mid": "Mezzo",
    "Right": "Destra",
    "Lower": "Inferiore",
    "Upper": "Superiore",
    "Contain": "Contiene",
    "Reports to": "Riferisce a",
    "Self": "Sé Stesso",
    "Average": "Media",
    "Equals": "Equivale a",
    "Total": "Totale",
    "Maximum": "Massimo",
    "Minimum": "Minimo",
    "Variance": "Variante",
    "Standard Deviation": "Deviazione Standard",
    "Years": "Anni",
    "Day": "Giorno",
    "count": "Conto",
    "Level": "Livello",
    "Sub": "Subordinata",
    "All": "Tutte",
    "Next Level Sub": "Subordinata di Livello Successivo",
    "All Sub": "Tutte le Subordinate",
    "Value": "Valore",
    "Property": "Proprietà",
    "confirm": "OK",
    "cancel": "Annulla"
  },
  "tw": {
    "title": "公式",
    "type": "類型",
    "function": "函數",
    "range": "範圍",
    "charra": "晚間",
    "start": "開始",
    "characters": "角色",
    "string": "字符",
    "assistants": "助手",
    "self": "自身",
    "Len": "長度",
    "Left": "左",
    "Mid": "中",
    "Right": "右",
    "Lower": "小寫",
    "Upper": "大寫",
    "Contain": "包含",
    "Reports to": "報告給",
    "Self": "自身",
    "Average": "平均數",
    "Equals": "等於",
    "Total": "總數",
    "Maximum": "最大",
    "Minimum": "最小",
    "Variance": "方差",
    "Standard Deviation": "標準差",
    "Years": "年",
    "Day": "日",
    "count": "計數",
    "Level": "同級",
    "Sub": "附屬",
    "All": "全部",
    "Next Level Sub": "下一層級附屬",
    "All Sub": "全部附屬",
    "Value": "值",
    "Property": "屬性",
    "confirm": "確定",
    "cancel": "取消"
  },
  "kr": {
    "title": "공식",
    "type": "종류",
    "function": "함수",
    "range": "범위",
    "charra": "야간",
    "start": "시작",
    "characters": "역할",
    "string": "문자",
    "assistants": "조수",
    "self": "자신",
    "Len": "길이",
    "Left": "왼쪽",
    "Mid": "중간 ",
    "Right": "오른쪽",
    "Lower": "소문자",
    "Upper": "대문자",
    "Contain": "포함",
    "Reports to": "보고 대상",
    "Self": "자신",
    "Average": "평균수",
    "Equals": "동등하다",
    "Total": "총수",
    "Maximum": "최대값",
    "Minimum": "최소값",
    "Variance": "분산",
    "Standard Deviation": "표준 편차",
    "Years": "년",
    "Day": "일",
    "count": "수를 세기",
    "Level": "레벨",
    "Sub": "종속",
    "All": "전부",
    "Next Level Sub": "하층부속",
    "All Sub": "전부 부속",
    "Value": "값",
    "Property": "속성",
    "confirm": "확인 ",
    "cancel": "취소"
  }
}
</i18n>
